/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'fabric.reactions.add': 'Tilføj reaktion',
  'fabric.reactions.add.new': 'Tilføj ny',
  'fabric.reactions.error.unexpected': 'Reaktioner er midlertidigt utilgængelige',
  'fabric.reactions.loading': 'Indlæser ...',
  'fabric.reactions.more.emojis': 'Flere emojis',
  'fabric.reactions.other.reacted.users': '{count, plural, one {og én anden} other {og {count} andre}}',
  'fabric.reactions.reactwithemoji': 'Reager med emojien {emoji}',
  'fabric.reactions.reactwithemojiandcount':
    '{count, plural, one {{count,number} {emoji}-emoji. Reager med emojien {emoji}} other {{count,number} {emoji}-emojier. Reager med emojien {emoji}}}',
  'fabric.reactions.summary': 'Se alle brugerreaktioner',
  'reaction-picker-trigger.add.reaction.message': 'Tilføj en reaktion',
  'reactions-reaction.picker-label': 'Tilføj reaktioner',
  'reactions.dialog.close': 'Luk',
  'reactions.dialog.emoji.name': '{emojiName}',
  'reactions.dialog.left.navigate': 'Navigation til venstre',
  'reactions.dialog.reactions.count':
    '{count, plural, one {{count,number} reaktion i alt} other {{count,number} reaktioner i alt}}',
  'reactions.dialog.right.navigate': 'Navigation til højre',
  'reactions.dialog.viewall': 'Vis alle',
  'reactions.dialog.viewall.tooltip': 'Se alle brugerreaktioner',
};
